import React from 'react';
import { colors } from '../../../../theme';
export var CancelX = function CancelX(props) {
  return /*#__PURE__*/React.createElement("svg", {
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.866 2.47447L24.5298 24.1382",
    stroke: props.color || colors.WHITE,
    strokeWidth: "".concat(props.strokeWidth || 3),
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.1382 2.47447L2.47446 24.1382",
    stroke: props.color || colors.WHITE,
    strokeWidth: "".concat(props.strokeWidth || 3),
    strokeLinecap: "square"
  }));
};